module.exports = __webpack_public_path__ + "img/quickteller.dc36a1e1.png";